import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import VKTemplate1 from "../components/VKTemplate1";
import { API_HEADERS } from "./config";

export default function VKTwoMarkPage() {
  const [params] = useSearchParams();
  const api = params.get("api");   // ⭐ API received from URL

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!api) {
      alert("API link missing");
      return;
    }

    fetch(api, { headers: API_HEADERS })
      .then((res) => res.json())
      .then((result) => {
        if (Array.isArray(result)) {
          setRows(result);
        } else if (result.data) {
          setRows(result.data);
        } else {
          setRows([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [api]);

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  return <VKTemplate1 rows={rows} />;
}
